import { useQuery } from "@tanstack/react-query";
import { getProjectDashboard } from "@/app/actions/project/dashboard/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProjectDashboard(projectId?: number, enabled = true) {
  return useQuery({
    queryKey: [QueryKey.PROJECT_DASHBOARD, projectId],
    queryFn: () => getProjectDashboard(projectId!),
    enabled: enabled && !!projectId,
    staleTime: Infinity,
  });
}
